<div
  class="dialog-draggable-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  [cdkDragConstrainPosition]="computeDragRenderPos.bind(this)"
>
  <mat-icon>drag_indicator</mat-icon>
</div>
<div class="dialog-header">
  <span mat-dialog-title>
    {{ 'modal_dialog_please_select' | translate }}
    {{ 'topnavbar_menu_viewasuser_user_selection_dialog_title' | translate }}
  </span>
</div>
<div mat-dialog-content class="dialog-with-bottom-buttons">
  <!-- DIALOG CONTENT -->
  <div id="entity-table" class="entity-table">
    <div class="table-wrapper">
      <!-- SEARCH & PAGINATOR START-->
      <div class="table-search-paginate hidden-filters">
        <div class="table-search-paginate-left-wrapper">
          <mat-form-field appearance="outline" class="reset-outline-hint filter-field search">
            @if (filter) {
              <button mat-icon-button matSuffix class="small-icon" (click)="clearSearchFilter(); $event.stopPropagation()">
                <mat-icon>clear</mat-icon>
              </button>
            }
            <mat-autocomplete
              (opened)="matAutocompletPanelOpened()"
              (closed)="matAutocompletPanelClosed()"
              #autoLastStringOption="matAutocomplete"
              (optionSelected)="applyFilterTable($event.option.value)"
            >
              @if (lastUsedFilters?.length > 0) {
                <mat-option class="form-field-option label-option" [disabled]="true">
                  {{ 'label_recent_searches' | translate }}
                </mat-option>
              }
              @for (opt of lastUsedFilters; track opt) {
                <mat-option class="form-field-option" [value]="opt" [class.mat-selected]="filter === opt">
                  {{ opt }}
                </mat-option>
              }
            </mat-autocomplete>
            <input
              #searchInputField
              #searchInputAutocompleteTrigger="matAutocompleteTrigger"
              (input)="searchInputAutocompleteTrigger.closePanel()"
              matInput
              [(ngModel)]="filter"
              [matAutocomplete]="autoLastStringOption"
              attr.aria-label="{{ 'label_table_filter' | translate }}"
              (debounceFilterInput)="applyFilterTable($event)"
              [debounceTime]="600"
              maxlength="1500"
              placeholder="{{ 'table_filter_placeholder' | translate }}"
            />
          </mat-form-field>
          @if (searchFilterrules) {
            <span style="padding-right: 0.5rem"></span>
            <div class="search-filterrules">
              <mat-button-toggle-group
                [hideMultipleSelectionIndicator]="true"
                class="topics"
                #kindButtonGroup="matButtonToggleGroup"
                [multiple]="true"
                [value]="[selectedFilteruleId]"
                (change)="setFilterRule($event.value)"
              >
                <mat-button-toggle [value]="1">
                  <span>{{ 'label_exact_match' | translate }}</span>
                </mat-button-toggle>
                <mat-button-toggle [value]="2">
                  <span>{{ 'label_begin_with' | translate }}</span>
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          }
        </div>
        <div class="table-search-paginate-right">
          @if (showFilters) {
            <button mat-button color="primary" (click)="enableFilter = !enableFilter">
              {{ enableFilter ? ('label_hide_filters' | translate) : ('label_more_filters' | translate) }}
            </button>
            @if (isFiltersSetted()) {
              <button mat-button color="warn" (click)="clearFilters()">
                {{ 'label_reset_filters' | translate }}
              </button>
            }
          }
        </div>
      </div>
      @if (gridFiltersConfig) {
        <div class="table-filters" [ngClass]="enableFilter ? 'visible' : 'hidden'">
          @for (filter of gridFiltersConfig; track filter) {
            @if (!filter.isDateFilter) {
              <generic-grid-filter-panel
                [clearFilter]="clearFilterSubject.asObservable()"
                [filtersMapSubj]="filtersMapSubject.asObservable()"
                [filterName]="filter.filterParams"
                [filterApiPath]="filter.filterApiPath"
                filterTitle="{{ filter.filterTitle | translate }}"
                (filterIdsEvEm)="setFiltersIds($event, filter.filterParams)"
              ></generic-grid-filter-panel>
            }
            @if (filter.isDateFilter) {
              <generic-grid-filter-date-panel
                [clearFilter]="clearFilterSubject.asObservable()"
                [filtersMapSubj]="filtersMapSubject.asObservable()"
                [filterName]="filter.filterParams"
                filterTitle="{{ filter.filterTitle | translate }}"
                (filterDatesEvEm)="setFiltersIds($event, filter.filterParams)"
              ></generic-grid-filter-date-panel>
            }
          }
        </div>
      }
      <div class="table-container">
        @if (isGridView) {
          <table
            class="table table-stripes table-truncate-text"
            mat-table
            [dataSource]="dataSourceTable"
            matSort
            #sortTable="matSort"
            [matSortActive]="gbGetInitialOrderBy()"
            [matSortDirection]="gbGetInitialSort()"
            matSortDisableClear
            [matSortActive]="'entityName'"
            [matSortDirection]="'asc'"
          >
            <!-- radio button column -->
            <ng-container matColumnDef="radio">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row" class="radio-button-wrapper">
                @if (row.userEnabled) {
                  <mat-radio-button
                    class="table-radio-button"
                    (change)="row.userEnabled ? onEntitySelected(row) : null"
                    disableRipple="true"
                    [checked]="selectedEntity && selectedEntity.entityId === row.entityId"
                  ></mat-radio-button>
                }
              </td>
            </ng-container>
            <!-- Configurable columns -->
            @if (gridColumnsConfig) {
              @for (c of gridColumnsConfig; track c.entityField) {
                <ng-container matColumnDef="{{ c.entityField }}">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="{ width: c.columnWidth != null ? c.columnWidth : '' }">
                    {{ c.columnTitleKey | translate }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row"
                    [matTooltip]="getTooltipString(c, row)"
                    showIfTruncated
                    [ngStyle]="{ width: c.columnWidth != null ? c.columnWidth : '' }"
                    [ngClass]="c.columnType === 'tooltip' ? 'tooltip-cell' : ''"
                  >
                    @switch (c.columnType) {
                      @case ('date') {
                        <span>{{ getDate(row[c.entityField]) }}</span>
                      }
                      @case ('timestamp') {
                        <span>{{ getTimestamp(row[c.entityField]) }}</span>
                      }
                      @case ('price') {
                        <span>{{
                          row[c.entityField] != null
                            ? getMoney(row[c.entityField])
                            : c.columnPriceSwitchField
                              ? row[c.columnPriceSwitchField]
                              : ''
                        }}</span>
                      }
                      @case ('factor') {
                        <span>{{ getFactor(row[c.entityField]) }}</span>
                      }
                      @case ('percentage') {
                        <span>{{ getPercentageNormalized(row[c.entityField]) }}</span>
                      }
                      @case ('boolean') {
                        <span>
                          @if (row[c.entityField]) {
                            <mat-icon style="height: auto; vertical-align: middle; color: green; font-size: 20px">check</mat-icon>
                          }
                        </span>
                      }
                      @case ('tooltip') {
                        @if (!row[c.entityField]) {
                          <mat-icon matTooltip="{{ 'user_disabled_for_login' | translate }}" [matTooltipClass]="'fo-mat-tooltip'"
                            >info</mat-icon
                          >
                        }
                      }
                      @default {
                        <span>{{ row[c.entityField] }}</span>
                      }
                    }
                  </td>
                </ng-container>
              }
            }
            <tr mat-header-row *matHeaderRowDef="displayedColumnsTable; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumnsTable"
              [ngClass]="[
                selectedEntity && selectedEntity.entityId === row.entityId ? 'selected-row' : '',
                row.userEnabled ? '' : 'disabled-user',
              ]"
            ></tr>
          </table>
        }
        @if (noEntityData || isLoading) {
          <mat-toolbar class="table-footer-toolbar">
            @if (isLoading) {
              <mat-toolbar-row class="spinner">
                <mat-spinner diameter="50"></mat-spinner>
              </mat-toolbar-row>
            }
            @if (noEntityData) {
              <mat-toolbar-row class="no-data-message">
                <span>{{ 'generic_table_error_nodata' | translate }}</span>
              </mat-toolbar-row>
            }
          </mat-toolbar>
        }
        <mat-toolbar class="table-footer-toolbar">
          <mat-toolbar-row>
            <mat-paginator
              [disabled]="isLoading"
              #paginatorTable
              [pageSizeOptions]="pageSizeList"
              [length]="pageTotalElements"
              class="reset-paginator"
            ></mat-paginator>
          </mat-toolbar-row>
        </mat-toolbar>
      </div>
    </div>
  </div>
  <div class="particulars-form no-background dialog-bottom-buttons">
    <div class="particulars-row no-label">
      <div class="particulars-col"></div>
      <div class="particulars-col"></div>
      <div class="particulars-col float-right">
        <span class="control-value button float-right">
          <button mat-stroked-button color="primary" [mat-dialog-close]="null" style="margin-right: 0.5rem">
            <span>{{ 'label_cancel' | translate }}</span>
          </button>
          <button mat-flat-button color="primary" (click)="onSelect()" [disabled]="!isEntitySelected()">
            <span>{{ 'label_select' | translate }}</span>
          </button>
        </span>
      </div>
    </div>
  </div>
  <!-- END DIALOG CONTENT -->
</div>
